import { gql } from '@apollo/client'

export const SYSTEM_PROCESS_CREATE_MUTATION = gql`
  mutation SYSTEM_PROCESS_CREATE_MUTATION($input: SystemProcessInput!) {
    systemProcessCreate(input: $input) {
      data {
        id
      }
    }
  }
`

export const SYSTEM_PROCESS_UPDATE_MUTATION = gql`
  mutation SYSTEM_PROCESS_UPDATE_MUTATION($id: ID!, $input: SystemProcessInput!) {
    systemProcessUpdate(id: $id, input: $input) {
      data {
        id
      }
    }
  }
`

export const SYSTEM_PROCESS_DELETE_MUTATION = gql`
  mutation SYSTEM_PROCESS_DELETE_MUTATION($id: ID!) {
    systemProcessDelete(id: $id) {
      ok
    }
  }
`

export const PREVIEW_EMAIL = gql`
  mutation PREVIEW_EMAIL($input: PreviewEmailInput!) {
    previewEmail(input: $input) {
      subject
      template
    }
  }
`

export const RUN_AUTOMATIONS_MUTATION = gql`
  mutation RUN_AUTOMATIONS_MUTATION {
    runAutomations {
      ok
    }
  }
`

export const CHECK_INLINE_FUNCTIONS = gql`
  mutation CHECK_INLINE_FUNCTIONS($input: CheckAndNotifyInlineFunctionVisibilityInput!) {
    checkAndNotifyInlineFunctionVisibility(input: $input) {
      ok
    }
  }
`

export const CHECK_INLINE_FUNCTIONS_PUBLIC = gql`
  mutation CHECK_INLINE_FUNCTIONS_PUBLIC($domain: String!, $input: CheckAndNotifyInlineFunctionVisibilityInput!) {
    checkAndNotifyInlineFunctionVisibilityPublic(domain: $domain, input: $input) {
      ok
    }
  }
`

export const EXECUTE_INLINE_FUNCTION = gql`
  mutation EXECUTE_INLINE_FUNCTION($input: ExecuteInlineFunctionTransactionInput!) {
    executeInlineFunctionTransaction(input: $input) {
      ok
    }
  }
`

export const EXECUTE_INLINE_FUNCTION_PUBLIC = gql`
  mutation EXECUTE_INLINE_FUNCTION_PUBLIC($domain: String!, $input: ExecuteInlineFunctionTransactionInput!) {
    executeInlineFunctionTransactionPublic(domain: $domain, input: $input) {
      ok
    }
  }
`

export const RUN_STRATEGY_PROCESSES_BY_ACTION_MUTATION = gql`
  mutation RUN_STRATEGY_PROCESSES_BY_ACTION_MUTATION($input: RunStrategyProcessesByActionInput!) {
    runStrategyProcessesByAction(input: $input) {
      ok
    }
  }
`
